import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d8d72f8e&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d8d72f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d72f8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8d72f8e')) {
      api.createRecord('d8d72f8e', component.options)
    } else {
      api.reload('d8d72f8e', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d8d72f8e&scoped=true&", function () {
      api.rerender('d8d72f8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wMcPJoPmJQrS/JS/comp/DocBox.vue"
export default component.exports